import blogCardFeatured from "./blogCardFeatured"
export default blogCardFeatured;
